// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrelanderV6Page__container--DGaA6 {
    position: relative;
    background-color: #07080B;
    width: 100%;
    min-height: 100vh;
    min-height: calc(var(--vh) * 100);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
}

    @media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {.PrelanderV6Page__container--DGaA6 {
        min-height: 100vh
}
    }

.PrelanderV6Page__headerWrapper--W9_N_ {
    width: 100%;
    background-color: var(--dark-primary-new-color);
}

.PrelanderV6Page__header--m9XyO {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    max-width: 640px;
    margin: 0 auto;
    padding: 12px 0;
}

@media screen and (max-width: 1023px) {

.PrelanderV6Page__header--m9XyO {
        padding: 8px 24px
}
    }

.PrelanderV6Page__headerMainInformation--H6mBg {
    display: flex;
    align-items: center;
    gap: 24px;
}

@media screen and (min-width: 1024px) {

.PrelanderV6Page__headerMainInformation--H6mBg {
        gap: 32px
}
    }

.PrelanderV6Page__headerTitle--kB6Tc {
    color: #646979;
    font-size: 10px;
    font-weight: 500;
    line-height: 12px;
    border-left: 1px solid #646979;
    padding-left: 8px;
}

@media screen and (min-width: 1024px) {

.PrelanderV6Page__headerTitle--kB6Tc {
        font-size: 12px;
        line-height: 16px;
        padding-left: 16px
}
    }

.PrelanderV6Page__logo--wNhNJ > img {
        width: 103px;
        height: 24px;
    }

.PrelanderV6Page__progressText--HB6nr {
    font-size: 12px;
    font-weight: 500;
    line-height: 40px;
    color: var(--dark-fourth-new-color);
}

.PrelanderV6Page__progressIndicator--fMRIg {
    width: 100%;
    height: 4px;
    background-color: var(--dark-secondary-new-color);
    overflow: hidden;
    position: relative;
}

.PrelanderV6Page__progressActiveBar--bwdHS {
    transition: width 0.25s linear;
    background-color: var(--secondary-color);
    border-radius: 0px 2px 2px 0px;
    height: 4px;
    position: relative;
    z-index: 2;
}

.PrelanderV6Page__main--JQCM9 {
    max-width: 640px;
    margin: 0 auto;
    text-align: center;
}

@media screen and (max-width: 1023px) {

.PrelanderV6Page__mainWithIndent--mV89e {
        padding: 0 24px
}
    }

.PrelanderV6Page__mainWithLarge--uC5Ur {
    max-width: 1080px;
}

.PrelanderV6Page__mainWithBig--dhgVf {
    max-width: 948px;
}

.PrelanderV6Page__label--TU8kT {
    display: block;
    color: var(--secondary-color);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

.PrelanderV6Page__title--q4stO {
    color: var(--tertiary-color);
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

@media screen and (max-width: 1023px) {

.PrelanderV6Page__title--q4stO {
        padding: 0 24px
}
    }

@media screen and (min-width: 1024px) {

.PrelanderV6Page__title--q4stO {
        margin-bottom: 24px;
        font-size: 20px;
        line-height: 28px
}
    }

.PrelanderV6Page__secondaryTitle--i9t_6 {
    color: var(--tertiary-color);
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: 0.16px;
    text-transform: uppercase;
    margin-bottom: 24px;
}

@media screen and (min-width: 1024px) {

.PrelanderV6Page__secondaryTitle--i9t_6 {
        font-size: 20px;
        line-height: 1.4;
        letter-spacing: 0.2px
}
    }

@media screen and (max-width: 1023px) {

.PrelanderV6Page__secondaryTitleWithoutIndentOnMobile--yv6NL {
        margin-bottom: 0
}
    }

.PrelanderV6Page__titleWithIndent--sxrf0 {
    margin-bottom: 28px;
}

.PrelanderV6Page__cardsLeftText--nl4ib {
    color: var(--premium-solid-color);
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.16px;
    text-transform: uppercase;
}

@media screen and (min-width: 1024px) {

.PrelanderV6Page__cardsLeftText--nl4ib {
        font-size: 20px;
        line-height: 28px;
        letter-spacing: 0.2px
}
    }

@media screen and (min-width: 1024px) {

.PrelanderV6Page__starCardSelectorStage--Zh8Fm {
        max-width: 640px;
        grid-gap: 20px
}
    }

.PrelanderV6Page__description--yG128 {
    color: var(--premium-solid-color);
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    padding: 0 16px;
    max-width: 640px;
    margin: 0 auto;
}

.PrelanderV6Page__description--yG128 > strong {
        font-weight: 900;
    }

@media screen and (min-width: 1024px) {

.PrelanderV6Page__description--yG128 {
        font-size: 20px;
        line-height: 28px
}
    }

.PrelanderV6Page__image--oAAmO {
    width: 100%;
    height: auto;
    aspect-ratio: 1.8;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
    background-blend-mode: screen, normal;
}

@media screen and (min-width: 1024px) {

.PrelanderV6Page__image--oAAmO {
        aspect-ratio: 1.91
}
    }

.PrelanderV6Page__rewardBlock--hsbzB {
    position: relative;
}

.PrelanderV6Page__rewardImage--LjN0j {
    width: 100%;
    height: auto;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
    aspect-ratio: 1.3333;
}

.PrelanderV6Page__teamPowerIndicator--spZu6 {
    margin: 24px 0;
}

.PrelanderV6Page__seasonTournamentRewardsImageWrapper--nPyA2 {
    width: 100%;
    overflow: hidden;
}

@media screen and (max-width: 1023px) {

.PrelanderV6Page__seasonTournamentRewardsImageWrapper--nPyA2 {
        width: calc(100% + 48px);
        left: -24px;
        position: relative
}
    }

.PrelanderV6Page__seasonTournamentRewardsImage--GtbeM {
    width: 100%;
    min-width: 420px;
    height: auto;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}

.PrelanderV6Page__button--uVFIn {
    margin: 0 auto;
    width: 100%;
    max-width: 200px;
    display: flex;
}

@media screen and (max-width: 1023px) {

.PrelanderV6Page__button--uVFIn {
        width: calc(100% - 48px);
        max-width: 400px
}
    }

.PrelanderV6Page__footer--MdgEm {
    padding-bottom: 16px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderV6Page__footer--MdgEm {
        padding-bottom: 24px
}
    }

.PrelanderV6Page__copyrightText--eIaQh {
    color: var(--dark-fourth-new-color);
    text-align: center;
    font-size: 8px;
    font-weight: 500;
    line-height: 12px;
    letter-spacing: 0.08px;
    text-transform: uppercase;
}

@media screen and (max-width: 1023px) {

.PrelanderV6Page__copyrightText--eIaQh {
        padding: 0 24px
}
    }

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderV6Page__copyrightText--eIaQh {
        margin: 0 auto;
        max-width: 604px;
        font-size: 10px;
        line-height: 16px;
        letter-spacing: 0.1px
}
    }

@media screen and (max-width: 1023px) {

.PrelanderV6Page__hiddenOnMobile--Uu1lo {
        display: none !important
}
    }
`, "",{"version":3,"sources":["webpack://./src/pages/PrelanderV6Page/PrelanderV6Page.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;AAKb;;IAHI,8FAXJ;QAYQ;AAER;IADI;;AAGJ;IACI,WAAW;IACX,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,cAAc;IACd,eAAe;AAKnB;;AAHI;;AATJ;QAUQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AAKb;;AAHI;;AALJ;QAMQ;AAER;IADI;;AAGJ;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,iBAAiB;AAOrB;;AALI;;AARJ;QASQ,eAAe;QACf,iBAAiB;QACjB;AAER;IADI;;AAIA;QACI,YAAY;QACZ,YAAY;IAChB;;AAGJ;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iDAAiD;IACjD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,wCAAwC;IACxC,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAGI;;AADJ;QAEQ;AAER;IADI;;AAGJ;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;AAWtB;;AATI;;AATJ;QAUQ;AAQR;IAPI;;AAEA;;AAbJ;QAcQ,mBAAmB;QACnB,eAAe;QACf;AAER;IADI;;AAGJ;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AAOvB;;AALI;;AAVJ;QAWQ,eAAe;QACf,gBAAgB;QAChB;AAER;IADI;;AAIA;;AADJ;QAEQ;AAER;IADI;;AAGJ;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAO7B;;AALI;;AATJ;QAUQ,eAAe;QACf,iBAAiB;QACjB;AAER;IADI;;AAIA;;AADJ;QAEQ,gBAAgB;QAChB;AAER;IADI;;AAGJ;IACI,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAUlB;;AARI;QACI,gBAAgB;IACpB;;AAEA;;AAhBJ;QAiBQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;IACvB,qCAAqC;AAKzC;;AAHI;;AARJ;QASQ;AAER;IADI;;AAGJ;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AAOpB;;AALI;;AAJJ;QAKQ,wBAAwB;QACxB,WAAW;QACX;AAER;IADI;;AAGJ;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,aAAa;AAMjB;;AAJI;;AANJ;QAOQ,wBAAwB;QACxB;AAER;IADI;;AAGJ;IACI,oBAAoB;AAKxB;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,mCAAmC;IACnC,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAa7B;;AAXI;;AATJ;QAUQ;AAUR;IATI;;AAEA;;AAbJ;QAcQ,cAAc;QACd,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB;AAER;IADI;;AAIA;;AADJ;QAEQ;AAER;IADI","sourcesContent":[".container {\n    position: relative;\n    background-color: #07080B;\n    width: 100%;\n    min-height: 100vh;\n    min-height: calc(var(--vh) * 100);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 24px;\n\n    @media (--large), (--small-tablet) {\n        min-height: 100vh;\n    }\n}\n\n.headerWrapper {\n    width: 100%;\n    background-color: var(--dark-primary-new-color);\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    max-width: 640px;\n    margin: 0 auto;\n    padding: 12px 0;\n\n    @media (--mobile) {\n        padding: 8px 24px;\n    }\n}\n\n.headerMainInformation {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n\n    @media (--large) {\n        gap: 32px;\n    }\n}\n\n.headerTitle {\n    color: #646979;\n    font-size: 10px;\n    font-weight: 500;\n    line-height: 12px;\n    border-left: 1px solid #646979;\n    padding-left: 8px;\n\n    @media (--large) {\n        font-size: 12px;\n        line-height: 16px;\n        padding-left: 16px;\n    }\n}\n\n.logo {\n    > img {\n        width: 103px;\n        height: 24px;\n    }\n}\n\n.progressText {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 40px;\n    color: var(--dark-fourth-new-color);\n}\n\n.progressIndicator {\n    width: 100%;\n    height: 4px;\n    background-color: var(--dark-secondary-new-color);\n    overflow: hidden;\n    position: relative;\n}\n\n.progressActiveBar {\n    transition: width 0.25s linear;\n    background-color: var(--secondary-color);\n    border-radius: 0px 2px 2px 0px;\n    height: 4px;\n    position: relative;\n    z-index: 2;\n}\n\n.main {\n    max-width: 640px;\n    margin: 0 auto;\n    text-align: center;\n}\n\n.mainWithIndent {\n    @media (--mobile) {\n        padding: 0 24px;\n    }\n}\n\n.mainWithLarge {\n    max-width: 1080px;\n}\n\n.mainWithBig {\n    max-width: 948px;\n}\n\n.label {\n    display: block;\n    color: var(--secondary-color);\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n}\n\n.title {\n    color: var(--tertiary-color);\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.2px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n\n    @media (--mobile) {\n        padding: 0 24px;\n    }\n\n    @media (--large) {\n        margin-bottom: 24px;\n        font-size: 20px;\n        line-height: 28px;\n    }\n}\n\n.secondaryTitle {\n    color: var(--tertiary-color);\n    text-align: center;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.25;\n    letter-spacing: 0.16px;\n    text-transform: uppercase;\n    margin-bottom: 24px;\n\n    @media (--large) {\n        font-size: 20px;\n        line-height: 1.4;\n        letter-spacing: 0.2px;\n    }\n}\n\n.secondaryTitleWithoutIndentOnMobile {\n    @media (--mobile) {\n        margin-bottom: 0;\n    }\n}\n\n.titleWithIndent {\n    margin-bottom: 28px;\n}\n\n.cardsLeftText {\n    color: var(--premium-solid-color);\n    text-align: center;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.16px;\n    text-transform: uppercase;\n\n    @media (--large) {\n        font-size: 20px;\n        line-height: 28px;\n        letter-spacing: 0.2px;\n    }\n}\n\n.starCardSelectorStage {\n    @media (--large) {\n        max-width: 640px;\n        grid-gap: 20px;\n    }\n}\n\n.description {\n    color: var(--premium-solid-color);\n    text-align: center;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.2px;\n    text-transform: uppercase;\n    padding: 0 16px;\n    max-width: 640px;\n    margin: 0 auto;\n\n    > strong {\n        font-weight: 900;\n    }\n\n    @media (--large) {\n        font-size: 20px;\n        line-height: 28px;\n    }\n}\n\n.image {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1.8;\n    object-fit: contain;\n    object-position: center;\n    background-blend-mode: screen, normal;\n\n    @media (--large) {\n        aspect-ratio: 1.91;\n    }\n}\n\n.rewardBlock {\n    position: relative;\n}\n\n.rewardImage {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    object-position: center;\n    aspect-ratio: 1.3333;\n}\n\n.teamPowerIndicator {\n    margin: 24px 0;\n}\n\n.seasonTournamentRewardsImageWrapper {\n    width: 100%;\n    overflow: hidden;\n\n    @media (--mobile) {\n        width: calc(100% + 48px);\n        left: -24px;\n        position: relative;\n    }\n}\n\n.seasonTournamentRewardsImage {\n    width: 100%;\n    min-width: 420px;\n    height: auto;\n    position: relative;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.button {\n    margin: 0 auto;\n    width: 100%;\n    max-width: 200px;\n    display: flex;\n\n    @media (--mobile) {\n        width: calc(100% - 48px);\n        max-width: 400px;\n    }\n}\n\n.footer {\n    padding-bottom: 16px;\n\n    @media (--large), (--small-tablet) {\n        padding-bottom: 24px;\n    }\n}\n\n.copyrightText {\n    color: var(--dark-fourth-new-color);\n    text-align: center;\n    font-size: 8px;\n    font-weight: 500;\n    line-height: 12px;\n    letter-spacing: 0.08px;\n    text-transform: uppercase;\n\n    @media (--mobile) {\n        padding: 0 24px;\n    }\n\n    @media (--large), (--small-tablet) {\n        margin: 0 auto;\n        max-width: 604px;\n        font-size: 10px;\n        line-height: 16px;\n        letter-spacing: 0.1px;\n    }\n}\n\n.hiddenOnMobile {\n    @media (--mobile) {\n        display: none !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PrelanderV6Page__container--DGaA6`,
	"headerWrapper": `PrelanderV6Page__headerWrapper--W9_N_`,
	"header": `PrelanderV6Page__header--m9XyO`,
	"headerMainInformation": `PrelanderV6Page__headerMainInformation--H6mBg`,
	"headerTitle": `PrelanderV6Page__headerTitle--kB6Tc`,
	"logo": `PrelanderV6Page__logo--wNhNJ`,
	"progressText": `PrelanderV6Page__progressText--HB6nr`,
	"progressIndicator": `PrelanderV6Page__progressIndicator--fMRIg`,
	"progressActiveBar": `PrelanderV6Page__progressActiveBar--bwdHS`,
	"main": `PrelanderV6Page__main--JQCM9`,
	"mainWithIndent": `PrelanderV6Page__mainWithIndent--mV89e`,
	"mainWithLarge": `PrelanderV6Page__mainWithLarge--uC5Ur`,
	"mainWithBig": `PrelanderV6Page__mainWithBig--dhgVf`,
	"label": `PrelanderV6Page__label--TU8kT`,
	"title": `PrelanderV6Page__title--q4stO`,
	"secondaryTitle": `PrelanderV6Page__secondaryTitle--i9t_6`,
	"secondaryTitleWithoutIndentOnMobile": `PrelanderV6Page__secondaryTitleWithoutIndentOnMobile--yv6NL`,
	"titleWithIndent": `PrelanderV6Page__titleWithIndent--sxrf0`,
	"cardsLeftText": `PrelanderV6Page__cardsLeftText--nl4ib`,
	"starCardSelectorStage": `PrelanderV6Page__starCardSelectorStage--Zh8Fm`,
	"description": `PrelanderV6Page__description--yG128`,
	"image": `PrelanderV6Page__image--oAAmO`,
	"rewardBlock": `PrelanderV6Page__rewardBlock--hsbzB`,
	"rewardImage": `PrelanderV6Page__rewardImage--LjN0j`,
	"teamPowerIndicator": `PrelanderV6Page__teamPowerIndicator--spZu6`,
	"seasonTournamentRewardsImageWrapper": `PrelanderV6Page__seasonTournamentRewardsImageWrapper--nPyA2`,
	"seasonTournamentRewardsImage": `PrelanderV6Page__seasonTournamentRewardsImage--GtbeM`,
	"button": `PrelanderV6Page__button--uVFIn`,
	"footer": `PrelanderV6Page__footer--MdgEm`,
	"copyrightText": `PrelanderV6Page__copyrightText--eIaQh`,
	"hiddenOnMobile": `PrelanderV6Page__hiddenOnMobile--Uu1lo`
};
export default ___CSS_LOADER_EXPORT___;
